export enum Journeys {
  EXPERIENCE_GIFT_FIRST = 'experience-gift-first',
  EXPERIENCE_GIFT_FIRST_UPGRADED = 'experience-gift-first-upgraded',
  EXPERIENCE_GIFT_FIRST_EXISTING = 'experience-gift-first-existing',
}
